/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit IntervalAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from '../helpers.js'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function IntervalAction({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Topbar/LowerSection/SlotIntervalAction/IntervalAction",
  id,
  isSubmitting,
  isSelectedSlot,
  isSelected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let settingsIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'settings',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtColorsGreen200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.200'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  id,
  isSubmitting,
  isSelectedSlot
  
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
  return (<React.Fragment
>
<button
  data-testid="IntervalAction.Vertical"
  data-view-path={viewPath}
 id={id}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--w-1-1Vc3ka': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--h-2-1Vc3ka': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--btlr-3-1Vc3ka': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-4-1Vc3ka': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-5-1Vc3ka': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-6-1Vc3ka': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--c-9-1Vc3ka': settingsIsSubmittingData ? "not-allowed" : "pointer",'--bc-7-1Vc3ka': isSelectedSlot ? dtColorsGreen200 : dtColorsWhite,'--bc-8-1Vc3ka': isSelectedSlot ? dtColorsGreen700 : dtColorsNeutral300}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="IntervalAction.Vertical:1"
  data-view-path={viewPath}
 style={{'--h-2-1Vc3ka': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--w-1-1Vc3ka': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--btlr-3-1Vc3ka': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btrr-4-1Vc3ka': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bblr-5-1Vc3ka': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bbrr-6-1Vc3ka': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bc-8-1Vc3ka': dtColorsNeutral300,'--bc-7-1Vc3ka': isSelectedSlot ? dtColorsGreen700 : dtColorsNeutral400}}
 className={`views-block ${styles.Vertical1}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
</div>
</button>
</React.Fragment>)
}